<template>
  <eg-modal
    id="custom-instructions-preview-modal"
    :title="$t('rubrics.customInstructions')"
    size="md"
    centered
    modal-class="eg-rubric-modal"
  >
    <div class="preview-text">
      {{ customInstructions }}
    </div>
    <template #footer="{ close }">
      <eg-button type="secondary" @click="close">{{
        $t("common.close")
      }}</eg-button>
    </template>
  </eg-modal>
</template>

<script>
export default {
  name: "CustomInstructionsPreviewModal",
  props: {
    customInstructions: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-text {
  white-space: pre-line;
}
</style>
